import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  children: ReactNode | ReactNode[];
};

const ErrorMessage = styled.div`
  padding: 20px;
  margin: 20px auto;
  max-width: 80vw;
  background-color: rgba(0, 0, 0, 0.05);
  text-align: center;
  & p {
    margin: 0;
  }
  & p + p {
    margin-top: 1em;
  }
`;

export const Error = ({ children }: Props) => {
  return <ErrorMessage>{children}</ErrorMessage>;
};
